import { Component, OnInit } from '@angular/core';
import { SidePanelService } from '../shared/services/side-pannel/side-pannel.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-logout-confirmation',
  templateUrl: './logout-confirmation.component.html',
  styleUrls: ['./logout-confirmation.component.scss']
})
export class LogoutConfirmationComponent implements OnInit {

  constructor(
    private sidePanelService:SidePanelService,
    private matDialogRef: MatDialogRef<LogoutConfirmationComponent>
  ) { }

  ngOnInit(): void {
  }

  closeDialog():void{
    this.matDialogRef.close();
  }

  logout():void{
    this.matDialogRef.close();
    this.sidePanelService.logout();
  }

}
